import type Phaser from "phaser";

import type { CoinRewardFeedback } from "../application/coin-reward-feedback";
import { gameplayConfig } from "../config/gameplay-config";
import type { MotionProfile } from "../config/motion-config";

export const drawCoinRewardSparks = (
  graphics: Phaser.GameObjects.Graphics,
  feedback: CoinRewardFeedback | null,
  simulationTimeMs: number,
  motionProfile: MotionProfile,
): void => {
  if (feedback === null) {
    return;
  }
  const duration = gameplayConfig.playerStatus.feedbackDurationMs;
  const age = simulationTimeMs - feedback.startedAtMs;
  if (age < 0 || age >= duration) {
    return;
  }
  const tuning = gameplayConfig.coinRewardFeedback;
  const reducedMotion = motionProfile.particleOpacity === 0;
  const progress = age / duration;
  const distance =
    tuning.sparkStartDistance +
    (reducedMotion ? 0 : tuning.sparkTravelDistance * progress);
  const alpha = reducedMotion ? 0.95 : 1 - progress;
  graphics.fillStyle(0xffe066, alpha);
  for (let index = 0; index < tuning.sparkCount; index += 1) {
    const angle = (index / tuning.sparkCount) * Math.PI * 2;
    graphics.fillCircle(
      feedback.position.x + Math.cos(angle) * distance,
      feedback.position.y + Math.sin(angle) * distance - 18,
      tuning.sparkRadius,
    );
  }
};
